import { createContext, useContext, useState, useEffect } from 'react';
import { register } from '../serviceWorkerRegistration';

const UpdateContext = createContext();

export function UpdateProvider({ children }) {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [registration, setRegistration] = useState(null);

    useEffect(() => {
        // Register service worker with update handlers
        register({
            onUpdate: (reg, hasUpdate) => {
                setRegistration(reg);
                setUpdateAvailable(hasUpdate);
            },
            onSuccess: (reg) => {
                setRegistration(reg);
            }
        });
    }, []);

    const performUpdate = () => {
        if (registration && registration.waiting) {
            // Send skipWaiting message to the waiting service worker
            registration.waiting.postMessage({ type: 'skipWaiting' });

            // Wait for the service worker to activate before reloading
            registration.waiting.addEventListener('statechange', (event) => {
                if (event.target.state === 'activated') {
                    // Service worker is now active, safe to reload
                    window.location.reload();
                }
            });
        } else {
            // Fallback: reload immediately if no waiting worker
            window.location.reload();
        }
    };

    return (
        <UpdateContext.Provider value={{ updateAvailable, performUpdate }}>
            {children}
        </UpdateContext.Provider>
    );
}

export const useUpdate = () => {
    const context = useContext(UpdateContext);
    if (context === undefined) {
        throw new Error('useUpdate must be used within an UpdateProvider');
    }
    return context;
}; 